import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { pageHead } from "@/lib/route-head";
const JoinWaitlist = lazy(() => import("@/pages/JoinWaitlist"));

export const Route = createFileRoute("/join/")({
  component: JoinWaitlist,
  head: () =>
    pageHead({
      path: "/join",
      title: "Join the Interest List — Amorette",
      description:
        "Tell us your city and what you’re looking for. We’ll email you when curated Amorette evenings open near you — free, and never a reservation.",
    }),
});
